<template>
    <div class="checkout__progression-bar d-flex">
        <div
            v-for="checkoutStep in checkoutSteps"
            class="mx-auto justify-content-center align-items-center checkout__progression-bar--bar-item"
            :class="[ paymentStep === checkoutStep.checkoutStep ? 'checkout__progression-bar--border-bottom-green' : 'checkout__progression-bar--border-bottom-white' ]"
        >
            <div
                class="checkout__progression-bar--dot d-flex justify-content-center align-items-center text-white px-1 mr-md-2"
                :class="[ paymentStep >= checkoutStep.checkoutStep ? 'checkout__progression-bar--green-dot' : 'checkout__progression-bar--gray-dot' ]"
            >
                <div>{{ checkoutStep.checkoutStep }}</div>
            </div>
            <div
                class="ml-1 my-auto"
                :class="{ 'text--gray': paymentStep < checkoutStep.checkoutStep}"
            >
                {{ checkoutStep.title }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            paymentStep: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                checkoutSteps: [
                    {
                        checkoutStep: 1,
                        title: this.$i18n.t("checkout.progressbarLogIn"),
                    },
                    {
                        checkoutStep: 2,
                        title: this.$i18n.t("checkout.progressbarPaymentOption")
                    },
                    {
                        checkoutStep: 3,
                        title: this.$i18n.t("checkout.progressbarPayment")
                    },
                    {
                        checkoutStep: 4,
                        title: this.$i18n.t("checkout.progressbarDone")
                    }
                ],
                activeStep: false,
            };
        },
        methods: {},
        mounted() {

        }
    };
</script>
